import { LocalStorageManager } from 'services/storage/LocalStorageManager';

export function shouldAutoSelect(projectsCount: number): boolean {
  return projectsCount === 1 && !LocalStorageManager.wasProjectSelected();
}
